import React from "react";

/**
 * Package 0 Safety Freeze — reusable in-line notice.
 * Rendered in place of superseded payment / delivery / donor-communication
 * controls while Secure Export MVP is active.
 */
export default function SafetyFreezeNotice({
  title = "Temporarily unavailable",
  message = "This control is not part of the current release.",
  testId = "safety-freeze-notice",
}) {
  return (
    <div
      data-testid={testId}
      style={{
        border: "1px solid #f5c451",
        background: "#fff8e6",
        color: "#7a5a00",
        borderRadius: 8,
        padding: "14px 16px",
        margin: "12px 0",
        fontSize: 14,
        lineHeight: 1.4,
      }}
    >
      <div style={{ fontWeight: 600, marginBottom: 4 }}>{title}</div>
      <div>{message}</div>
    </div>
  );
}
